var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHamburgerMenu(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 14"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.5.333h15V2H.5V.333zm0 5.834h15v1.666H.5V6.167zM.5 12h15v1.667H.5V12z",
    fill: "#5C5C8E"
  })));
}
export default __webpack_public_path__ + "static/svg/hamburger-menu.svg";
export { SvgHamburgerMenu as ReactComponent };